export const reportOptions = {
  alternateRowStyles: { fillColor: [245, 245, 245] }
  , margin: { top: 45, bottom: 20 }
  , headStyles: { fillColor: [41, 128, 186] }
  , footStyles: { fillColor: [41, 128, 186] }
  , showHead: "everyPage"
  , showFoot: "lastPage"
  , theme: "grid"
};